import { gql } from "@apollo/client";

export const GET_ORDERS_METRIX_SUMMARY = gql`
  query ordersMetricsSummary {
    ordersMetricsSummary {
      totalSuccessfullOrders
      totalOrdersToday
    }
  }
`;
